import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { DiaryType } from '../../../../data/tracker/domain/diary_type/diary_type';
import { DiaryTypeUtils } from '../../../../data/tracker/domain/diary_type/diary_type_utils';
import { TrackerCellModel } from '../tracker-manager/tracker-manager.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-event-cell',
  templateUrl: './event-cell.component.html',
  styleUrls: ['./event-cell.component.scss'],
})
export class EventCellComponent implements OnInit {
  @Input() type: DiaryType;
  @Input() loading: boolean;
  @Input() selectedType: DiaryType;
  @Input() trackers: TrackerCellModel[];
  @Input() activeTrackers?: number;
  @Output() onEdit = new EventEmitter<DiaryType>();
  @Output() onMask = new EventEmitter<DiaryType>();

  public diaryUtils: DiaryTypeUtils;

  ngOnInit(): void {
    this.diaryUtils = new DiaryTypeUtils();
  }

  get activeTrackersCount() {
    return this.trackers?.filter((tracker) => tracker.checked)?.length ?? 0;
  }

  public offsetDropdown(bAct: HTMLUListElement, height: number): boolean {
    const pos = bAct.getBoundingClientRect();
    return window.innerHeight - (pos.top + window.scrollY) - height < 0;
  }
}
